/** Trim ends and collapse whitespace to single spaces. */
export function normalizeMembershipName(raw) {
  if (raw == null) return "";
  return String(raw).trim().replace(/\s+/g, " ");
}

/** Must match `tbl_memberships.membership_name` VARCHAR(100). */
export const MEMBERSHIP_NAME_MAX_LEN = 100;

/** While typing: allow only letters, digits, spaces; collapse repeated spaces. */
export function sanitizeMembershipNameInput(raw) {
  const s = String(raw ?? "").replace(/[^a-zA-Z0-9 ]/g, "");
  return s.replace(/\s+/g, " ").slice(0, MEMBERSHIP_NAME_MAX_LEN);
}

export const MEMBERSHIP_NAME_PATTERN = /^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)*$/;

export function validateMembershipName(trimmed) {
  if (!trimmed) return "Membership name is required";
  if (trimmed.length < 4) return "At least 4 characters required";
  if (trimmed.length > MEMBERSHIP_NAME_MAX_LEN) {
    return `At most ${MEMBERSHIP_NAME_MAX_LEN} characters`;
  }
  if (!MEMBERSHIP_NAME_PATTERN.test(trimmed)) {
    return "Letters and numbers only; single spaces between words (no special characters)";
  }
  return null;
}

/** Non-negative decimal; empty allowed while editing. */
export function parseNonNegativeNumber(v) {
  if (v === "" || v === null || v === undefined) return "";
  const n = parseFloat(String(v));
  if (Number.isNaN(n)) return "";
  return Math.max(0, n);
}

/** Positive integer cap; empty while editing. */
export function parsePositiveIntCap(v) {
  if (v === "" || v === null || v === undefined) return "";
  const n = parseInt(String(v), 10);
  if (Number.isNaN(n)) return "";
  return Math.max(0, n);
}
